import { Box, CircularProgress } from "@app/ui-kit";

export const LoadingScreen = ({ minHeight = "40vh" }: { minHeight?: string | number }) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight }}>
    <CircularProgress color="secondary" size={28} />
  </Box>
);
